import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import Button from "../../../../shared/components/elements/Button";
import Wrapper from "../../../../shared/components/layout/Wrapper";
import { LESSON_MESSAGES } from "../../messages";

interface FooterLessonProps {
    goPrevious?: () => void;
    goNext?: () => void;
    hasPrevious?: boolean;
    hasNext?: boolean;
    isLastScreen?: boolean;
}

const FooterLesson = ({
                          goPrevious,
                          goNext,
                          hasPrevious = false,
                          hasNext = false,
                          isLastScreen = false
                      }: FooterLessonProps) => {
    return (
        <footer className="w-full flex items-center border-t-4 border-gray-200 py-5">
            <Wrapper>
                <div className="flex items-center justify-between">
                    <Button onClick={goPrevious} disabled={!hasPrevious}>
                        {/* Chevrons mirror in RTL so "previous" always points the way you came from */}
                        <FontAwesomeIcon icon={faChevronLeft} className="rtl:rotate-180" />
                        <span>{LESSON_MESSAGES.previous}</span>
                    </Button>

                    {/* On the last screen the button finishes the lesson instead of moving on */}
                    <Button onClick={goNext} disabled={!hasNext}>
                        <span>{isLastScreen ? LESSON_MESSAGES.finishLesson : LESSON_MESSAGES.next}</span>
                        <FontAwesomeIcon
                            icon={isLastScreen ? faCheck : faChevronRight}
                            className={isLastScreen ? undefined : "rtl:rotate-180"}
                        />
                    </Button>
                </div>
            </Wrapper>
        </footer>
    );
};

export default FooterLesson;